module.exports = __webpack_public_path__ + "static/img/button.aef17657.png";